import { Injectable, inject } from '@angular/core';
import { catchError, firstValueFrom, lastValueFrom, Observable, of } from 'rxjs';
import { HttpClient, HttpRequest } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { OrganisationsTyp } from '../../domain/model/organisationsTyp';
import { Anleitungsdokument } from '../../domain/model/anleitung';
import { map, tap } from 'rxjs/operators';
import { NeueAnleitung } from '../../domain/model/neueanleitung';

@Injectable({
    providedIn: 'root',
})
export class AnleitungService {
    private http = inject(HttpClient);


    public anleitungPresentForRole$: Observable<Boolean> = null;

    public reloadAnleitungPresent() {
        this.anleitungPresentForRole$ = this.isAnleitungPresentForRole();
    }

    public async uploadAnleitung(neueAnleitung: NeueAnleitung, callback: any) {
        const formData: FormData = new FormData();
        formData.append('file', neueAnleitung.file, neueAnleitung.file.name);
        const req = new HttpRequest('POST',
            `${environment.API_URL}/anleitung/${neueAnleitung.organisationsTyp}`,
            formData, {
                reportProgress: true,
            });
        return lastValueFrom(
            this.http.request(req).pipe(
                tap(event => callback.handleUploadEvent(event)),
                map(() => true),
                catchError((reason: any) => {
                    console.log('reason:' + reason);
                    return of(false);
                }),
            ),
        );
    }

    listAllAnleitungen(): Observable<Anleitungsdokument[]> {
        return this.http.get<Anleitungsdokument[]>(environment.API_URL + '/anleitung/listAllAnleitungen');
    }

    createEmptyAnleitungsDokumentFor(organisationsTyp: OrganisationsTyp) {
        return {
            organisationsTyp,
            downloading: false,
            size: 0,
            fileName: null,
        };
    }

    getAnleitungByRole(organisationsTyp: OrganisationsTyp): Observable<Blob> {
        return this.http.get<Blob>(environment.API_URL + '/anleitung/file/' + organisationsTyp);
    }

    private isAnleitungPresentForRole(): Observable<Boolean> {
        return this.http.get<Boolean>(environment.API_URL + '/anleitung/available');
    }

    deleteAnleitungByRole(organisationsTyp: OrganisationsTyp) {
        return this.http.delete(environment.API_URL + '/anleitung/' + organisationsTyp).toPromise();
    }

    async downloadFile(organisationsTyp: OrganisationsTyp): Promise<void> {
        const fileResponse = await firstValueFrom(this.http.get(`${environment.API_URL}/anleitung/${organisationsTyp}/download`,
            {
                responseType: 'blob',
                observe: 'response',
            }),
        );
        const a = document.createElement('a');
        console.log(fileResponse.body.type);
        const file = new Blob([
            fileResponse.body,
        ], { type: fileResponse.body.type });

        const objectUrl = URL.createObjectURL(file);
        a.href = objectUrl;
        a.download = `anleitung_${organisationsTyp}`;
        a.click();
        URL.revokeObjectURL(objectUrl);
    }
}
